import React from "react";

import "./styles.scss";

import { Container, Row, Col } from "reactstrap";
import IconPlus from "../../../../components/Icons/IconPlus";
import IconArrows from "../../../../components/Icons/IconArrows";
import IconLines from "../../../../components/Icons/IconLines";
import IconLogoFull from "../../../../components/Icons/IconLofoFull";

const Banner = () => (
    <Container fluid tag="section" className="banner">
        <Row tag="article" className="justify-content-center align-items-end h-100">
            <Col className="text-center">
                <IconArrows width="40" height="40" />
                <h1 className="title mb-5">Abrieron las insripciones a nuestro<br/>
                    <IconPlus width="40" height="40" /> Máster 2026 <IconPlus width="40" height="40" />
                </h1>
                <a href="/contacto" className="banner__cta">QUIERO INSCRIBIRME</a>
                <div className="mt-2">
                    <IconLines width="70" height="110" />
                    <span className="icon-logo d-none d-lg-inline-block">
                        <IconLogoFull width="160" height="50" />
                    </span>
                </div>
            </Col>
        </Row>
    </Container>
);

export default Banner;
